<template>
    <div class="piscreen">
        
        <PlayerSelection v-if="!playerChosen" v-on:player-chosen="setPlayer" :darkmode="true"></PlayerSelection>
        <StatusMessage v-if="statusMessage" :message="statusMessage" category="" :redirect="true"></StatusMessage>

        <div class="topBar">
            <div class="home">
                <a href="/"><font-awesome-icon icon="home" /></a>
            </div>
            <div class="home">
                <a href="/leaderboard"><font-awesome-icon icon="trophy" /></a>
            </div>
            <div class="home">
                <a href="/playeroptions"><font-awesome-icon icon="user-cog" /></a>
            </div>
            <div class="home active">
                <a href="/playermilestones"><font-awesome-icon icon="user-check" /></a>
            </div>
        </div>

        <div class="header">
            <div class="description">
                <h2>Persoonlijke Statistieken</h2>
                <p>Hier zie je wat je in totaal gegooid hebt (alle seizoenen bij elkaar)</p>
            </div>
        </div>


        <div class="personalMilestones" v-if="playerChosen">
            <!-- SINGLES -->
            <div class="category singles" id="singles">
                <header>
                    <h2>Singles</h2>
                    <p>3 darts in hetzelfde getal</p>
                </header>
                <div class="player">
                    <div class="name">
                        {{ player.name }}
                    </div>
                    <div class="milestones">
                        <table>
                            <tr>
                                <td v-for="n in 20" v-bind:class="{ enabled: player.singles.includes(String(n)) }">{{ n }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <!-- DOUBLES 2X -->
            <div class="category intermediate" id="doubles2x">
                <header>
                    <h2>Doubles (2x)</h2>
                    <p>2 darts in dezelfde double</p>
                </header>
                <div class="player">
                    <div class="name">
                        {{ player.name }}
                    </div>
                    <div class="milestones">
                        <table>
                            <tr>
                                <td v-for="n in 20" v-bind:class="{ enabled: player.doubles2x.includes(String(n)) }">{{ n }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <!-- DOUBLES 3X -->
            <div class="category hard" id="doubles3x">
                <header>
                    <h2>Doubles (3x)</h2>
                    <p>3 darts in dezelfde double</p>
                </header>
                <div class="player">
                    <div class="name">
                        {{ player.name }}
                    </div>
                    <div class="milestones">
                        <table>
                            <tr>
                                <td v-for="n in 20" v-bind:class="{ enabled: player.doubles3x.includes(String(n)) }">{{ n }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <!-- TRIPLES 2X -->
            <div class="category intermediate" id="triples2x">
                <header>
                    <h2>Triples (2x)</h2>
                    <p>2 darts in dezelfde triple</p>
                </header>
                <div class="player">
                    <div class="name">
                        {{ player.name }}
                    </div>
                    <div class="milestones">
                        <table>
                            <tr>
                                <td v-for="n in 20" v-bind:class="{ enabled: player.triples2x.includes(String(n)) }">{{ n }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <!-- TRIPLES 3X -->
            <div class="category hard" id="triples3x">
                <header>
                    <h2>Triples (3x)</h2>
                    <p>3 darts in dezelfde triple</p>
                </header>
                <div class="player">
                    <div class="name">
                        {{ player.name }}
                    </div>
                    <div class="milestones">
                        <table>
                            <tr>
                                <td v-for="n in 20" v-bind:class="{ enabled: player.triples3x.includes(String(n)) }">{{ n }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <!-- SHANGHAI -->
            <div class="category hard" id="shanghai">
                <header>
                    <h2>Shanghai</h2>
                    <p>Een single, double en triple in hetzelfde getal</p>
                </header>
                <div class="player">
                    <div class="name">
                        {{ player.name }}
                    </div>
                    <div class="milestones">
                        <table>
                            <tr>
                                <td v-for="n in 20" v-bind:class="{ enabled: player.shanghai.includes(String(n)) }">{{ n }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <!-- ROBIN HOOD -->
            <div class="category hard" id="robinhood">
                <header>
                    <h2>Robin Hood</h2>
                    <p class="robinHoodDescription">Gooi een dart in een getal, en dan een dart achter in de 1<sup>e</sup> dart</p>
                </header>
                <div class="player">
                    <div class="name">
                        {{ player.name }}
                    </div>
                    <div class="milestones">
                        <table>
                            <tr>
                                <td v-for="n in 20" v-bind:class="{ enabled: player.robinhood.includes(String(n)) }">{{ n }}</td>

                                <td v-bind:class="{ enabled: player.robinhood.includes('bull') }">
                                    <!-- BULL -->
                                    <span class="bull-icon hit"></span>
                                </td>

                                <td v-bind:class="{ enabled: player.robinhood.includes('bullseye') }">
                                    <!-- BULLSEYE -->
                                    <span class="bullseye-icon hit"></span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <!-- BULL -->
            <div class="category hard" id="bull">
                <header>
                    <h2>Bull</h2>
                    <p>1 of meerdere darts in de bull of bullseye</p>
                </header>
                <div class="player">
                    <div class="name">
                        {{ player.name }}
                    </div>
                    <div class="milestones">
                        <table class="bull">
                            <tr>
                                
                                <td v-bind:class="{ enabled: player.bull.includes('G') }">
                                    <!-- BULL -->
                                    <span class="bull-icon hit"></span>
                                </td>
                                <td v-bind:class="{ enabled: player.bull.includes('GG') }">
                                    <!-- BULL -->
                                    <span class="bull-icon hit"></span>
                                    <!-- BULL -->
                                    <span class="bull-icon hit"></span>
                                </td>
                                <td v-bind:class="{ enabled: player.bull.includes('GGG') }">
                                    <!-- BULL -->
                                    <span class="bull-icon hit"></span>
                                    <!-- BULL -->
                                    <span class="bull-icon hit"></span>
                                    <!-- BULL -->
                                    <span class="bull-icon hit"></span>
                                </td>
                                <td v-bind:class="{ enabled: player.bull.includes('R') }">
                                    <!-- BULLSEYE -->
                                    <span class="bullseye-icon hit"></span>
                                </td>
                                <td v-bind:class="{ enabled: player.bull.includes('RR') }">
                                    <!-- BULLSEYE -->
                                    <span class="bullseye-icon hit"></span>
                                    <!-- BULLSEYE -->
                                    <span class="bullseye-icon hit"></span>
                                </td>
                                <td v-bind:class="{ enabled: player.bull.includes('RRR') }">
                                    <!-- BULLSEYE -->
                                    <span class="bullseye-icon hit"></span>
                                    <!-- BULLSEYE -->
                                    <span class="bullseye-icon hit"></span>
                                    <!-- BULLSEYE -->
                                    <span class="bullseye-icon hit"></span>
                                </td>
                                <td v-bind:class="{ enabled: player.bull.includes('GR') }">
                                    <!-- BULL -->
                                    <span class="bull-icon hit"></span>
                                    <!-- BULLSEYE -->
                                    <span class="bullseye-icon hit"></span>
                                </td>
                                <td v-bind:class="{ enabled: player.bull.includes('GGR') }">
                                    <!-- BULL -->
                                    <span class="bull-icon hit"></span>
                                    <!-- BULL -->
                                    <span class="bull-icon hit"></span>
                                    <!-- BULLSEYE -->
                                    <span class="bullseye-icon hit"></span>
                                </td>
                                <td v-bind:class="{ enabled: player.bull.includes('GRR') }">
                                    <!-- BULL -->
                                    <span class="bull-icon hit"></span>
                                    <!-- BULLSEYE -->
                                    <span class="bullseye-icon hit"></span>
                                    <!-- BULLSEYE -->
                                    <span class="bullseye-icon hit"></span>
                                </td>


                                
                                


                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>

import axios from 'axios'
import StatusMessage from './partials/StatusMessage'
import PlayerSelection from './partials/PlayerSelection'


export default {

    name: 'PlayerOptions',

    components: {
        StatusMessage: StatusMessage,
        PlayerSelection: PlayerSelection
    },

    data() {
        return {
            playerChosen: false,
            statusMessage: '',
            player: {
                id: '',
                name: '',
                title: '',
                singles: [],
                doubles2x: [],
                doubles3x: [],
                triples2x: [],
                triples3x: [],
                shanghai: [],
                robinhood: [],
                bull: [],
            },
           
            

            

        }
        
    },

    computed: {
        // totalScore() {
            
        //     let total = 0;

        //     total += this.titles.singles.score;
        //     total += this.titles.doubles2x.score;
        //     total += this.titles.doubles3x.score;
        //     total += this.titles.triples2x.score;
        //     total += this.titles.triples3x.score;
        //     total += this.titles.shanghai.score;
        //     total += this.titles.robinhood.score;
        //     total += this.titles.bull.score;
                


        //     return total;
        // }
    },

    methods: {
        

        setPlayer(player) {
            this.player.id = player.id;
            this.player.name = player.name;
            
            // this.loadMilestones(this.player.id);
            this.playerChosen = true;
            this.playerName = this.player.name;



            console.log(player.id)

            this.getSingles();
            this.getDoubles2x();
            this.getDoubles3x();
            this.getTriples2x();
            this.getTriples3x();
            this.getShanghai();
            this.getRobinhood();
            this.getBull();

        },

        

        getSingles() {

            const params = {
                params: {
                    user_id: this.player.id,
                    category: 'singles'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_from_all_seasons_by_user.php', params).then(function (response) {
                console.log(response);
                self.player.singles = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getDoubles2x() {

            const params = {
                params: {
                    user_id: this.player.id,
                    category: 'doubles_2x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_from_all_seasons_by_user.php', params).then(function (response) {
                console.log(response);
                self.player.doubles2x = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getDoubles3x() {

            const params = {
                params: {
                    user_id: this.player.id,
                    category: 'doubles_3x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_from_all_seasons_by_user.php', params).then(function (response) {
                console.log(response);
                self.player.doubles3x = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getTriples2x() {

            const params = {
                params: {
                    user_id: this.player.id,
                    category: 'triples_2x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_from_all_seasons_by_user.php', params).then(function (response) {
                console.log(response);
                self.player.triples2x = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getTriples3x() {

            const params = {
                params: {
                    user_id: this.player.id,
                    category: 'triples_3x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_from_all_seasons_by_user.php', params).then(function (response) {
                console.log(response);
                self.player.triples3x = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getShanghai() {

            const params = {
                params: {
                    user_id: this.player.id,
                    category: 'shanghai'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_from_all_seasons_by_user.php', params).then(function (response) {
                console.log(response);
                self.player.shanghai = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getRobinhood() {

            const params = {
                params: {
                    user_id: this.player.id,
                    category: 'robinhood'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_from_all_seasons_by_user.php', params).then(function (response) {
                console.log(response);
                self.player.robinhood = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getBull() {

            const params = {
                params: {
                    user_id: this.player.id,
                    category: 'bull'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_from_all_seasons_by_user.php', params).then(function (response) {
                console.log(response);
                self.player.bull = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        unlockDartGod() {
            if (this.titles.all.score == 151) {
                this.titles.all.unlocked = true;
            }
        }
        

        


    },



    mounted() {
        // this.getSingles();
        
    }
}
</script>


<style scoped>

    
    


    .piscreen {
        width: 800px;
        background: #444;
        min-height: 480px;
        color: #fff;
    }

    .topBar {

        background: #666;
        display: flex;
        height: 80px;
        /*align-items: center;*/
        /*border-bottom: 1px solid #bbb;*/

        box-shadow: 0px 1px 3px rgba(0,0,0,0.48);

    }
    .home {
        /*position: absolute;*/
        font-size: 32px;
        /*border: 1px solid #558b2f;*/
        border: 1px solid #222;
        margin: 10px 0 10px 10px;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        /*background: #aed581;*/
        background: #555;
        border-radius: 3px;
        /*height: 60px;*/
        left: 0px;
        top: 0px;
        cursor: pointer;
        user-select: none;
    }
    .home a {
        text-decoration: none;
        padding: 5px 15px 10px;
        display: block;
        color: #fff;
    }
    .active a {
        color: gold;
    }

    

    .category {
        margin-top: 50px;
        position: relative;
    }
    .category:nth-child(2) {
        /*margin-top: 0;*/
    }
    .category:nth-child(2) header {
        padding-top: 8px;
    }
    .category.singles {
        margin-top: 0;
    }

    .category h2 {
        text-align: center;
        margin: 0;
        text-transform: uppercase;
    }

    .category p {
        margin: 0;
        font-size: 20px;
        text-align: center;
        /*color: black;*/
    }

    .category header {
        padding: 5px 5px 10px;
        text-shadow: 1px 1px 2px #000;
        margin-bottom: 2px;
        color: white;
    }

    #singles header {
        background: #558b2f;
    }
    #doubles2x header,
    #doubles3x header {
        background: #1565c0;
    }
    #triples2x header,
    #triples3x header {
        background: #673ab7;
    }
    #shanghai header {
        background: #ad1457;
    }
    #robinhood header {
        background: #ef6c00;
    }
    #bull header {
        background: #c62828;
        color: white;
    }

    #singles table tr td.enabled {
        background: #aed581;
        border: 1px solid #558b2f;
    }
    #doubles2x table tr td.enabled,
    #doubles3x table tr td.enabled {
        background: #64b5f6;
        border: 1px solid #1565c0;
    }
    #triples2x table tr td.enabled,
    #triples3x table tr td.enabled {
        background: #b39ddb;
        border: 1px solid #673ab7;
    }
    #shanghai table tr td.enabled {
        background: #f06292;
        border: 1px solid #ad1457;
    }
    #robinhood table tr td.enabled {
        background: #ffb74d;
        border: 1px solid #ef6c00;
    }
    #bull table tr td.enabled {
        background: #e57373;
        border: 1px solid #c62828;
    }
    div.player {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 2px;
    }

    div.name,
    div.milestones {
        color: black;
    }

    div.name {
        width: 116px;
        text-align: right;
        color: #eee !important;
        padding-right: 5px;
        /*font-weight: bold;*/
        overflow: hidden;
    }



    table tr {
        border: 1px solid black;
    }

    table tr td {
        font-size: 16px;
        text-align: center;
        /*padding: 5px 10px;*/
        width: 32px;
        height: 32px;
        font-weight: bold;
        user-select: none;
    }

    table.bull tr td {
        width: auto;
        padding: 0 15px;
    }

    .player:nth-child(even) table tr td:not(.enabled) {
        background: #ddd;
        border: 1px solid #aaa;
    }
    .player:nth-child(odd) table tr td:not(.enabled) {
        background: #fff;
        border: 1px solid #ccc;
    }
    .category:last-child {
        /*margin-bottom: 20px;*/
        padding-bottom: 50px;
    }



    .bull-icon {
        height: 16px;
        width: 16px;
        border-radius: 50%;
        display: inline-block;
        position: relative;
        border: 1px solid #444;
        margin-top: 5px;
        margin-left: 1px;
        margin-right: 1px;
        /*margin-right: 5px;*/
        /*box-shadow: 0px 0px 3px #444;*/
    }

    .bull-icon.hit {
        background-color: #00e676;
    }

    .bull-icon.miss {
        background-color: #efe;
    }
    .bullseye-icon.miss {
        background-color: #fee;
    }

    .bullseye-icon {
        height: 16px;
        width: 16px;
        border-radius: 50%;
        display: inline-block;
        position: relative;
        border: 1px solid #444;
        margin-top: 5px;
        margin-left: 1px;
        margin-right: 1px;

        /*box-shadow: 0px 0px 3px #444;*/
    }

    .bullseye-icon.hit {
        background: #ff1744;
    }

    .personalMilestones {
        /*width: 672px;*/
        margin-top: 15px;
        /*margin-left: 15px;*/
    }

    div.name {
        width: 107px;
        text-align: right;
        /*color: #000 !important;*/
        padding-right: 5px;
        /*font-weight: bold;*/
        overflow: hidden;
    }

    .description {
        margin: 10px 20px 50px;
    }

    h2,
    h3 {
        font-weight: normal;
        text-transform: uppercase;
        margin: 0;
        /*text-shadow: 1px 1px 3px #000;*/
    }
    p {
        margin: 0;
    }

    .category header {
        /*display: flex;*/
        /*padding-left: 20px;*/
        /*align-items: center;*/
    }

    .category header h2 {
        /*width: 170px;*/
        /*padding-right: 20px;*/
        /*text-align: right;*/
    }

    /* De "e" in "1e" zorgt ervoor dat de tekst niet goed ge-aligned is */
    .category p.robinHoodDescription {
        margin-top: -3px;
    }
    
</style>
